import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

import MoveMEoutWrapper from "@components/layouts/moveMEoutWrapper";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <MoveMEoutWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#00ade6" />
                </div>
                <FormSection iconsFillColor="#00ade6" />
            </div>
        </MoveMEoutWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
